import React from 'react';

const LoaderSkeleton = ({ hasData }: { hasData: boolean }) => {
  return (
    <div data-testid="skeleton">
      {new Array(5).fill(0).map((_, id) => (
        <div
          key={id}
          data-testid="skeleton-item"
          className={`flex items-center border-t border-gray-300 py-[12px] ${
            hasData ? '' : 'first:border-t-0'
          }`}
        >
          <div className="h-[24px] w-full mr-4 animate-pulse rounded bg-gray-200">
            &nbsp;
          </div>
          <div className="text-right min-w-9 animate-pulse rounded bg-gray-200">
            &nbsp;
          </div>
        </div>
      ))}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default LoaderSkeleton;
